import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

export const StyledHero = styled(Box)(({ theme }) => ({
  height: '165px',
  width: '100%',
  position: 'absolute',
  top: '80px',
  left: '0px',
  backgroundImage: 'url(/images/headerBG.png)',
  backgroundSize: 'cover',
  backgroundPosition: '100%',
  backgroundRepeat: 'no-repeat',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
}))

export const StyledLinks = styled(Box)(({ theme }) => ({
  marginTop: '15px',
  '& a': {
    textDecoration: 'none',
    color: theme.palette.darkGray.main,
  },
  '& li': {
    display: 'inline-block',
    '&:not(:last-child)::after': {
      content: '"\\00a0/\\00a0"',
      color: theme.palette.darkGray.main,
      fontSize: '1.2rem',
      // fontWeight: 'bold',
      verticalAlign: 'bottom',
    },
    '& p': {
      display: 'inline-block',
    },
  },
}))

export const StyledLinkItem = styled(Box)(({ theme }) => ({
  display: 'inline-block',
}))
